/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInputBody1,
  EnvironmentBody,
  EnvironmentsOutputBody,
  ErrorModel,
  FeaturesBody,
  FeaturesInputBody,
  SetAddressInputBody,
  SiteBody,
  SiteDetailBody,
  SiteListBody,
  SitesListParams,
  SitesSetEnvironmentAddressHeaders,
  SitesUpdateHeaders,
  UpdateInputBody1
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type sitesListResponse200 = {
  data: SiteListBody
  status: 200
}

export type sitesListResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesListResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesListResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesListResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesListResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesListResponseSuccess = (sitesListResponse200) & {
  headers: Headers;
};
export type sitesListResponseError = (sitesListResponse401 | sitesListResponse403 | sitesListResponse404 | sitesListResponse422 | sitesListResponse500) & {
  headers: Headers;
};

export type sitesListResponse = (sitesListResponseSuccess | sitesListResponseError)

export const getSitesListUrl = (params?: SitesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites?${stringifiedParams}` : `/sites`
}

/**
 * Владелец платформы видит сайты всех тенантов; остальным выдача ограничена их тенантом, и ограничение подставляется сервером, а не берётся из параметра запроса.
 * @summary Список сайтов
 */
export const sitesList = async (params?: SitesListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesListResponse> => {

  return facetaFetch<sitesListResponse>(getSitesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSitesListQueryKey = (params?: SitesListParams,) => {
    return [
    `/sites`, ...(params ? [params] : [])
    ] as const;
    }


export const getSitesListQueryOptions = <TData = Awaited<ReturnType<typeof sitesList>>, TError = ErrorModel>(params?: SitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesList>>> = ({ signal }) => sitesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesListQueryResult = NonNullable<Awaited<ReturnType<typeof sitesList>>>
export type SitesListQueryError = ErrorModel


export function useSitesList<TData = Awaited<ReturnType<typeof sitesList>>, TError = ErrorModel>(
 params: undefined |  SitesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesList>>,
          TError,
          Awaited<ReturnType<typeof sitesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesList<TData = Awaited<ReturnType<typeof sitesList>>, TError = ErrorModel>(
 params?: SitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesList>>,
          TError,
          Awaited<ReturnType<typeof sitesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesList<TData = Awaited<ReturnType<typeof sitesList>>, TError = ErrorModel>(
 params?: SitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Список сайтов
 */

export function useSitesList<TData = Awaited<ReturnType<typeof sitesList>>, TError = ErrorModel>(
 params?: SitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesCreateResponse201 = {
  data: SiteBody
  status: 201
}

export type sitesCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type sitesCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesCreateResponseSuccess = (sitesCreateResponse201) & {
  headers: Headers;
};
export type sitesCreateResponseError = (sitesCreateResponse401 | sitesCreateResponse403 | sitesCreateResponse404 | sitesCreateResponse409 | sitesCreateResponse422 | sitesCreateResponse500) & {
  headers: Headers;
};

export type sitesCreateResponse = (sitesCreateResponseSuccess | sitesCreateResponseError)

export const getSitesCreateUrl = () => {




  return `/sites`
}

/**
 * Вместе с сайтом создаются оба его окружения — Production и Development. Отвечает 409, если короткое имя занято.
 * @summary Завести сайт
 */
export const sitesCreate = async (createInputBody1: NonReadonly<CreateInputBody1>, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<sitesCreateResponse>(getSitesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody1)
  }
);}





export const getSitesCreateQueryKey = (createInputBody1?: NonReadonly<CreateInputBody1>,) => {
    return [
    'POST', `/sites`, createInputBody1
    ] as const;
    }


export const getSitesCreateQueryOptions = <TData = Awaited<ReturnType<typeof sitesCreate>>, TError = ErrorModel>(createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesCreateQueryKey(createInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesCreate>>> = ({ signal }) => sitesCreate(createInputBody1, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof sitesCreate>>>
export type SitesCreateQueryError = ErrorModel


export function useSitesCreate<TData = Awaited<ReturnType<typeof sitesCreate>>, TError = ErrorModel>(
 createInputBody1: NonReadonly<CreateInputBody1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesCreate>>,
          TError,
          Awaited<ReturnType<typeof sitesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesCreate<TData = Awaited<ReturnType<typeof sitesCreate>>, TError = ErrorModel>(
 createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesCreate>>,
          TError,
          Awaited<ReturnType<typeof sitesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesCreate<TData = Awaited<ReturnType<typeof sitesCreate>>, TError = ErrorModel>(
 createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести сайт
 */

export function useSitesCreate<TData = Awaited<ReturnType<typeof sitesCreate>>, TError = ErrorModel>(
 createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesCreateQueryOptions(createInputBody1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesDeleteResponse204 = {
  data: void
  status: 204
}

export type sitesDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesDeleteResponseSuccess = (sitesDeleteResponse204) & {
  headers: Headers;
};
export type sitesDeleteResponseError = (sitesDeleteResponse401 | sitesDeleteResponse403 | sitesDeleteResponse404 | sitesDeleteResponse422 | sitesDeleteResponse500) & {
  headers: Headers;
};

export type sitesDeleteResponse = (sitesDeleteResponseSuccess | sitesDeleteResponseError)

export const getSitesDeleteUrl = (id: string,) => {




  return `/sites/${id}`
}

/**
 * Отправляет сайт в корзину вместе с окружениями и содержимым.
 * @summary Удалить сайт
 */
export const sitesDelete = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesDeleteResponse> => {

  return facetaFetch<sitesDeleteResponse>(getSitesDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSitesDeleteQueryKey = (id: string,) => {
    return [
    'DELETE', `/sites/${id}`
    ] as const;
    }


export const getSitesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof sitesDelete>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesDeleteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesDelete>>> = ({ signal }) => sitesDelete(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof sitesDelete>>>
export type SitesDeleteQueryError = ErrorModel


export function useSitesDelete<TData = Awaited<ReturnType<typeof sitesDelete>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDelete>>,
          TError,
          Awaited<ReturnType<typeof sitesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesDelete<TData = Awaited<ReturnType<typeof sitesDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDelete>>,
          TError,
          Awaited<ReturnType<typeof sitesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesDelete<TData = Awaited<ReturnType<typeof sitesDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить сайт
 */

export function useSitesDelete<TData = Awaited<ReturnType<typeof sitesDelete>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesDeleteQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesGetResponse200 = {
  data: SiteDetailBody
  status: 200
}

export type sitesGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesGetResponseSuccess = (sitesGetResponse200) & {
  headers: Headers;
};
export type sitesGetResponseError = (sitesGetResponse401 | sitesGetResponse403 | sitesGetResponse404 | sitesGetResponse422 | sitesGetResponse500) & {
  headers: Headers;
};

export type sitesGetResponse = (sitesGetResponseSuccess | sitesGetResponseError)

export const getSitesGetUrl = (id: string,) => {




  return `/sites/${id}`
}

/**
 * @summary Один сайт
 */
export const sitesGet = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesGetResponse> => {

  return facetaFetch<sitesGetResponse>(getSitesGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSitesGetQueryKey = (id: string,) => {
    return [
    `/sites/${id}`
    ] as const;
    }


export const getSitesGetQueryOptions = <TData = Awaited<ReturnType<typeof sitesGet>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesGet>>> = ({ signal }) => sitesGet(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesGetQueryResult = NonNullable<Awaited<ReturnType<typeof sitesGet>>>
export type SitesGetQueryError = ErrorModel


export function useSitesGet<TData = Awaited<ReturnType<typeof sitesGet>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesGet>>,
          TError,
          Awaited<ReturnType<typeof sitesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesGet<TData = Awaited<ReturnType<typeof sitesGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesGet>>,
          TError,
          Awaited<ReturnType<typeof sitesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesGet<TData = Awaited<ReturnType<typeof sitesGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Один сайт
 */

export function useSitesGet<TData = Awaited<ReturnType<typeof sitesGet>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesUpdateResponse200 = {
  data: SiteBody
  status: 200
}

export type sitesUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type sitesUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesUpdateResponseSuccess = (sitesUpdateResponse200) & {
  headers: Headers;
};
export type sitesUpdateResponseError = (sitesUpdateResponse401 | sitesUpdateResponse403 | sitesUpdateResponse404 | sitesUpdateResponse409 | sitesUpdateResponse422 | sitesUpdateResponse500) & {
  headers: Headers;
};

export type sitesUpdateResponse = (sitesUpdateResponseSuccess | sitesUpdateResponseError)

export const getSitesUpdateUrl = (id: string,) => {




  return `/sites/${id}`
}

/**
 * Меняет только переданные поля.
 * @summary Изменить сайт
 */
export const sitesUpdate = async (id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<sitesUpdateResponse>(getSitesUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInputBody1)
  }
);}





export const getSitesUpdateQueryKey = (id: string,
    updateInputBody1?: NonReadonly<UpdateInputBody1>,) => {
    return [
    'PATCH', `/sites/${id}`, updateInputBody1
    ] as const;
    }


export const getSitesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof sitesUpdate>>, TError = ErrorModel>(id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesUpdateQueryKey(id,updateInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesUpdate>>> = ({ signal }) => sitesUpdate(id,updateInputBody1,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof sitesUpdate>>>
export type SitesUpdateQueryError = ErrorModel


export function useSitesUpdate<TData = Awaited<ReturnType<typeof sitesUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesUpdate>>,
          TError,
          Awaited<ReturnType<typeof sitesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesUpdate<TData = Awaited<ReturnType<typeof sitesUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesUpdate>>,
          TError,
          Awaited<ReturnType<typeof sitesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesUpdate<TData = Awaited<ReturnType<typeof sitesUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить сайт
 */

export function useSitesUpdate<TData = Awaited<ReturnType<typeof sitesUpdate>>, TError = ErrorModel>(
 id: string,
    updateInputBody1: NonReadonly<UpdateInputBody1>,
    headers: SitesUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesUpdateQueryOptions(id,updateInputBody1,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesEnvironmentsResponse200 = {
  data: EnvironmentsOutputBody
  status: 200
}

export type sitesEnvironmentsResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesEnvironmentsResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesEnvironmentsResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesEnvironmentsResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesEnvironmentsResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesEnvironmentsResponseSuccess = (sitesEnvironmentsResponse200) & {
  headers: Headers;
};
export type sitesEnvironmentsResponseError = (sitesEnvironmentsResponse401 | sitesEnvironmentsResponse403 | sitesEnvironmentsResponse404 | sitesEnvironmentsResponse422 | sitesEnvironmentsResponse500) & {
  headers: Headers;
};

export type sitesEnvironmentsResponse = (sitesEnvironmentsResponseSuccess | sitesEnvironmentsResponseError)

export const getSitesEnvironmentsUrl = (id: string,) => {




  return `/sites/${id}/environments`
}

/**
 * Production и Development с их адресами, Production первым.
 * @summary Окружения сайта
 */
export const sitesEnvironments = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesEnvironmentsResponse> => {

  return facetaFetch<sitesEnvironmentsResponse>(getSitesEnvironmentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSitesEnvironmentsQueryKey = (id: string,) => {
    return [
    `/sites/${id}/environments`
    ] as const;
    }


export const getSitesEnvironmentsQueryOptions = <TData = Awaited<ReturnType<typeof sitesEnvironments>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesEnvironmentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesEnvironments>>> = ({ signal }) => sitesEnvironments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesEnvironmentsQueryResult = NonNullable<Awaited<ReturnType<typeof sitesEnvironments>>>
export type SitesEnvironmentsQueryError = ErrorModel


export function useSitesEnvironments<TData = Awaited<ReturnType<typeof sitesEnvironments>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesEnvironments>>,
          TError,
          Awaited<ReturnType<typeof sitesEnvironments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesEnvironments<TData = Awaited<ReturnType<typeof sitesEnvironments>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesEnvironments>>,
          TError,
          Awaited<ReturnType<typeof sitesEnvironments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesEnvironments<TData = Awaited<ReturnType<typeof sitesEnvironments>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Окружения сайта
 */

export function useSitesEnvironments<TData = Awaited<ReturnType<typeof sitesEnvironments>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesEnvironments>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesEnvironmentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesSetEnvironmentAddressResponse200 = {
  data: EnvironmentBody
  status: 200
}

export type sitesSetEnvironmentAddressResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesSetEnvironmentAddressResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesSetEnvironmentAddressResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesSetEnvironmentAddressResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesSetEnvironmentAddressResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesSetEnvironmentAddressResponseSuccess = (sitesSetEnvironmentAddressResponse200) & {
  headers: Headers;
};
export type sitesSetEnvironmentAddressResponseError = (sitesSetEnvironmentAddressResponse401 | sitesSetEnvironmentAddressResponse403 | sitesSetEnvironmentAddressResponse404 | sitesSetEnvironmentAddressResponse422 | sitesSetEnvironmentAddressResponse500) & {
  headers: Headers;
};

export type sitesSetEnvironmentAddressResponse = (sitesSetEnvironmentAddressResponseSuccess | sitesSetEnvironmentAddressResponseError)

export const getSitesSetEnvironmentAddressUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}`
}

/**
 * Адрес сайта и разрешённые источники заменяются целиком. Окружений у сайта ровно два, они заводятся вместе с сайтом — ни добавить, ни удалить их нельзя.
 * @summary Сохранить адрес окружения
 */
export const sitesSetEnvironmentAddress = async (id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesSetEnvironmentAddressResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<sitesSetEnvironmentAddressResponse>(getSitesSetEnvironmentAddressUrl(id,kind),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(setAddressInputBody)
  }
);}





export const getSitesSetEnvironmentAddressQueryKey = (id: string,
    kind: 'production' | 'development',
    setAddressInputBody?: NonReadonly<SetAddressInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}`, setAddressInputBody
    ] as const;
    }


export const getSitesSetEnvironmentAddressQueryOptions = <TData = Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesSetEnvironmentAddressQueryKey(id,kind,setAddressInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>> = ({ signal }) => sitesSetEnvironmentAddress(id,kind,setAddressInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesSetEnvironmentAddressQueryResult = NonNullable<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>>
export type SitesSetEnvironmentAddressQueryError = ErrorModel


export function useSitesSetEnvironmentAddress<TData = Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>,
          TError,
          Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesSetEnvironmentAddress<TData = Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>,
          TError,
          Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesSetEnvironmentAddress<TData = Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сохранить адрес окружения
 */

export function useSitesSetEnvironmentAddress<TData = Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    setAddressInputBody: NonReadonly<SetAddressInputBody>,
    headers: SitesSetEnvironmentAddressHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesSetEnvironmentAddress>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesSetEnvironmentAddressQueryOptions(id,kind,setAddressInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteFeaturesSetResponse200 = {
  data: FeaturesBody
  status: 200
}

export type siteFeaturesSetResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteFeaturesSetResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteFeaturesSetResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteFeaturesSetResponse409 = {
  data: ErrorModel
  status: 409
}

export type siteFeaturesSetResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteFeaturesSetResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteFeaturesSetResponseSuccess = (siteFeaturesSetResponse200) & {
  headers: Headers;
};
export type siteFeaturesSetResponseError = (siteFeaturesSetResponse401 | siteFeaturesSetResponse403 | siteFeaturesSetResponse404 | siteFeaturesSetResponse409 | siteFeaturesSetResponse422 | siteFeaturesSetResponse500) & {
  headers: Headers;
};

export type siteFeaturesSetResponse = (siteFeaturesSetResponseSuccess | siteFeaturesSetResponseError)

export const getSiteFeaturesSetUrl = (id: string,) => {




  return `/sites/${id}/features`
}

/**
 * Целиком. Включение заводит на Development то, чего ещё нет: «Пользователи», «Каталог и заказы» с магазином, форму «Заявки» — уже заведённое берётся как есть. Магазин на Production включается, если его коллекции там уже есть (иначе — при переносе). Выключение магазина останавливает оформление на обоих окружениях; данные не удаляются.
 * @summary Возможности сайта
 */
export const siteFeaturesSet = async (id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<siteFeaturesSetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<siteFeaturesSetResponse>(getSiteFeaturesSetUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(featuresInputBody)
  }
);}





export const getSiteFeaturesSetQueryKey = (id: string,
    featuresInputBody?: NonReadonly<FeaturesInputBody>,) => {
    return [
    'PUT', `/sites/${id}/features`, featuresInputBody
    ] as const;
    }


export const getSiteFeaturesSetQueryOptions = <TData = Awaited<ReturnType<typeof siteFeaturesSet>>, TError = ErrorModel>(id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteFeaturesSetQueryKey(id,featuresInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteFeaturesSet>>> = ({ signal }) => siteFeaturesSet(id,featuresInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteFeaturesSetQueryResult = NonNullable<Awaited<ReturnType<typeof siteFeaturesSet>>>
export type SiteFeaturesSetQueryError = ErrorModel


export function useSiteFeaturesSet<TData = Awaited<ReturnType<typeof siteFeaturesSet>>, TError = ErrorModel>(
 id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteFeaturesSet>>,
          TError,
          Awaited<ReturnType<typeof siteFeaturesSet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteFeaturesSet<TData = Awaited<ReturnType<typeof siteFeaturesSet>>, TError = ErrorModel>(
 id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteFeaturesSet>>,
          TError,
          Awaited<ReturnType<typeof siteFeaturesSet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteFeaturesSet<TData = Awaited<ReturnType<typeof siteFeaturesSet>>, TError = ErrorModel>(
 id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Возможности сайта
 */

export function useSiteFeaturesSet<TData = Awaited<ReturnType<typeof siteFeaturesSet>>, TError = ErrorModel>(
 id: string,
    featuresInputBody: NonReadonly<FeaturesInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteFeaturesSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteFeaturesSetQueryOptions(id,featuresInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sitesRestoreResponse200 = {
  data: SiteBody
  status: 200
}

export type sitesRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type sitesRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type sitesRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type sitesRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type sitesRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type sitesRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type sitesRestoreResponseSuccess = (sitesRestoreResponse200) & {
  headers: Headers;
};
export type sitesRestoreResponseError = (sitesRestoreResponse401 | sitesRestoreResponse403 | sitesRestoreResponse404 | sitesRestoreResponse409 | sitesRestoreResponse422 | sitesRestoreResponse500) & {
  headers: Headers;
};

export type sitesRestoreResponse = (sitesRestoreResponseSuccess | sitesRestoreResponseError)

export const getSitesRestoreUrl = (id: string,) => {




  return `/sites/${id}/restore`
}

/**
 * @summary Восстановить сайт
 */
export const sitesRestore = async (id: string, options?: Parameters<typeof facetaFetch>[1]): Promise<sitesRestoreResponse> => {

  return facetaFetch<sitesRestoreResponse>(getSitesRestoreUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSitesRestoreQueryKey = (id: string,) => {
    return [
    'POST', `/sites/${id}/restore`
    ] as const;
    }


export const getSitesRestoreQueryOptions = <TData = Awaited<ReturnType<typeof sitesRestore>>, TError = ErrorModel>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesRestoreQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesRestore>>> = ({ signal }) => sitesRestore(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof sitesRestore>>>
export type SitesRestoreQueryError = ErrorModel


export function useSitesRestore<TData = Awaited<ReturnType<typeof sitesRestore>>, TError = ErrorModel>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesRestore>>,
          TError,
          Awaited<ReturnType<typeof sitesRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesRestore<TData = Awaited<ReturnType<typeof sitesRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesRestore>>,
          TError,
          Awaited<ReturnType<typeof sitesRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesRestore<TData = Awaited<ReturnType<typeof sitesRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Восстановить сайт
 */

export function useSitesRestore<TData = Awaited<ReturnType<typeof sitesRestore>>, TError = ErrorModel>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesRestoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






